import {Component, EventEmitter, Input, Output} from '@angular/core';
import moment from 'moment';
import {MemberRelationData, Relation, RelationRole} from '../employment.model';
import {Member, Offer, OfferType} from 'src/app/marketplace/marketplace.model';
import {AuthService} from 'src/app/identity/auth.service';
import {HiddenRequestsService} from '../hidden-requests.service';
import {ModalService} from 'src/app/ui-library/modal/modal.service';
import {EmploymentService} from '../employment.service';

@Component({
    selector: 'app-job-request',
    templateUrl: './job-request.component.html',
    styleUrls: ['./job-request.component.scss'],
    standalone: false
})
export class JobRequestComponent {
    @Input() memberRelation: MemberRelationData;
    @Output() removed = new EventEmitter<string>();

    constructor(
        private auth: AuthService,
        private hiddenRequests: HiddenRequestsService,
        private modalService: ModalService,
        private employment: EmploymentService,
    ) {
    }

    private get _myRole(): RelationRole {
        return this.relation && this.relation.memberRole === 'Employee' ? 'Employer' : 'Employee';
    }

    get member(): Member {
        return this.memberRelation?.member;
    }

    get offer(): Offer {
        const visibleOffer: OfferType = this.auth.isGiver ? 'Job' : 'Assistance';
        return this.memberRelation.member.offers.find(o => o.offerType === visibleOffer);
    }

    get relation(): Relation {
        return this.memberRelation?.relation;
    }

    get unreadMessages(): number {
        return this.memberRelation?.unreadMessages || 0;
    }

    get isOnlineToday(): boolean {
        return this.member?.lastSeenOn
            ? moment().diff(moment(this.member.lastSeenOn), 'days') === 0
            : false;
    }

    async removeRequest($event: Event): Promise<void> {
        $event.preventDefault();
        $event.stopPropagation();

        const question = this.auth.isGiver
            ? $localize`:@@employment.jobRequest.removeConfirm.pa:Möchtest du diese Anfrage aus deiner Übersicht entfernen? Die Person kann dein Profil weiterhin sehen. Solltest du erneut kontaktiert werden, erscheint die Anfrage wieder.`
            : $localize`:@@employment.jobRequest.removeConfirm.an:Möchtest du diese Anfrage aus deiner Übersicht entfernen? Die Person kann dein Profil weiterhin sehen. Sollte sie dir erneut schreiben, erscheint die Anfrage wieder.`;

        const confirmed = await this.modalService.showCustomConfirmation(
            $localize`:@@employment.jobRequest.removeTitle:Anfrage entfernen`,
            question,
            '/assets/images/alert-octagon.svg',
            $localize`:@@employment.jobRequest.removeBtn:Entfernen`,
            $localize`:@@popup.btn.cancel:Abbrechen`,
        );

        if (!confirmed) {
            return;
        }

        if (this.relation?.memberId) {
            this.employment.hideConversation(this._myRole, this.relation.memberId).subscribe({
                complete: () => {
                    this.removed.emit(this.relation.memberId);
                }
            });
        } else {
            const fallbackId = this.memberRelation?.member?.id;
            if (fallbackId) {
                this.hiddenRequests.hide(fallbackId);
                this.removed.emit(fallbackId);
            }
        }
    }
}
